import React, { useState, useEffect, useContext } from 'react';
import { useParams, Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import '../styles/pages.css';

const AllVideos = () => {
  const { id } = useParams();
  const [course, setCourse] = useState(null);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [error, setError] = useState('');
  const { token } = useContext(AuthContext);

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const response = await fetch(`http://localhost:5000/api/courses/${id}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        if (data.success) {
          setCourse(data.course);
          
          // Extract all videos from modules and lessons
          const allVideos = [];
          let videoId = 1;
          
          if (data.course.modules && data.course.modules.length > 0) {
            data.course.modules.forEach(module => {
              if (module.lessons && module.lessons.length > 0) {
                module.lessons.forEach(lesson => {
                  if (lesson.videoUrl) {
                    allVideos.push({
                      id: videoId++,
                      title: lesson.title,
                      duration: lesson.duration || '0 mins',
                      videoUrl: lesson.videoUrl,
                      thumbnail: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=300&h=180&fit=crop'
                    });
                  }
                });
              }
            });
          }
          
          setVideos(allVideos);
          if (allVideos.length > 0) {
            setSelectedVideo(allVideos[0]);
          }
        } else {
          setError('Failed to load course');
        }
      } catch (err) {
        setError(err.message);
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    if (token && id) {
      fetchCourse();
    }
  }, [token, id]);

  if (loading) return <div className="container"><p>Loading videos...</p></div>;
  if (error) return <div className="container"><div className="alert alert-error">{error}</div></div>;
  if (!course) return <div className="container"><p>Course not found</p></div>;
  if (videos.length === 0) return <div className="container"><p>No videos available for this course yet.</p></div>;

  return (
    <div className="container">
      <Link to={`/course/${id}`} style={{ marginBottom: '1rem', display: 'inline-flex', alignItems: 'center', gap: '0.5rem', color: 'white', background: '#1a1a1a', padding: '0.6rem 1rem', borderRadius: '6px', textDecoration: 'none', fontWeight: 600, transition: 'all 300ms ease' }} onMouseOver={(e) => { e.currentTarget.style.background = '#2d2d2d'; e.currentTarget.style.transform = 'scale(1.02)'; }} onMouseOut={(e) => { e.currentTarget.style.background = '#1a1a1a'; e.currentTarget.style.transform = 'scale(1)'; }}>
        <i className="fas fa-arrow-left"></i> Back to Course
      </Link>

      <h1 style={{ marginBottom: '0.5rem' }}>All Course Videos</h1>
      <p style={{ color: '#999', marginBottom: '2rem' }}>{course.title}</p>

      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '2rem', marginBottom: '2rem' }}>
        {/* Main Video Player */}
        <div>
          {selectedVideo && (
            <div className="card">
              <div style={{
                width: '100%',
                backgroundColor: '#000',
                borderRadius: '0.5rem 0.5rem 0 0',
                overflow: 'hidden',
                aspectRatio: '16 / 9',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <img
                  src={selectedVideo.thumbnail}
                  alt={selectedVideo.title}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
              <div className="card-body">
                <h2>{selectedVideo.title}</h2>
                <p style={{ color: '#999', marginTop: '0.5rem' }}>
                  <i className="fas fa-clock"></i> {selectedVideo.duration}
                </p>
                <button className="button button-primary" style={{ marginTop: '1rem', width: '100%' }}>
                  <i className="fas fa-play"></i> Play Video
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Videos List */}
        <div>
          <div className="card">
            <div className="card-header">
              <h3>📚 Videos ({videos.length})</h3>
            </div>
            <div className="card-body" style={{ maxHeight: '500px', overflowY: 'auto', padding: '0' }}>
              {videos.map(video => (
                <div
                  key={video.id}
                  onClick={() => setSelectedVideo(video)}
                  style={{
                    padding: '1rem',
                    borderBottom: '1px solid #e8e8e8',
                    cursor: 'pointer',
                    backgroundColor: selectedVideo?.id === video.id ? '#f5f5f5' : 'transparent',
                    transition: 'background-color 0.2s',
                  }}
                  onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                  onMouseOut={(e) => e.currentTarget.style.backgroundColor = selectedVideo?.id === video.id ? '#f5f5f5' : 'transparent'}
                >
                  <h4 style={{ margin: '0 0 0.5rem 0', fontSize: '0.95rem' }}>{video.title}</h4>
                  <p style={{ margin: '0', fontSize: '0.85rem', color: '#999' }}>
                    <i className="fas fa-clock"></i> {video.duration}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* All Videos Grid */}
      <h2 style={{ marginBottom: '1rem' }}>All Videos</h2>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
        gap: '1.5rem',
        marginTop: '1.5rem'
      }}>
        {videos.map(video => (
          <div
            key={video.id}
            className="card"
            onClick={() => setSelectedVideo(video)}
            style={{ cursor: 'pointer', transition: 'transform 0.2s', border: selectedVideo?.id === video.id ? '2px solid #7A5107' : '1px solid #e8e8e8' }}
            onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-4px)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
          >
            <div style={{
              width: '100%',
              height: '140px',
              overflow: 'hidden',
              borderRadius: '0.5rem 0.5rem 0 0'
            }}>
              <img
                src={video.thumbnail}
                alt={video.title}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </div>
            <div className="card-body">
              <h4 style={{ margin: '0 0 0.5rem 0' }}>{video.title}</h4>
              <p style={{ margin: '0', fontSize: '0.85rem', color: '#999' }}>
                <i className="fas fa-clock"></i> {video.duration}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AllVideos;
